import { AuthGuard, redirectLoggedInTo, redirectUnauthorizedTo } from "@angular/fire/auth-guard";
import { Routes } from "@angular/router";
import { provideTranslocoScope } from "@jsverse/transloco";

export const routes: Routes = [
    {
        path: "",
        redirectTo: "login",
        pathMatch: "full"
    },
    {
        path: "deeplinks",
        providers: provideTranslocoScope("deeplinksRedirect"),
        loadComponent: () =>
            import("./features/deeplinks-redirect/deeplinks-redirect.component").then(
                (m) => m.DeeplinksRedirectComponent
            )
    },
    {
        path: "login",
        providers: provideTranslocoScope("login"),
        loadComponent: () => import("./features/login/login.component").then((m) => m.LoginComponent),
        canActivate: [AuthGuard],
        data: { authGuardPipe: () => redirectLoggedInTo(["dashboard"]) }
    },
    {
        path: "dashboard",
        providers: provideTranslocoScope("dashboard"),
        loadComponent: () => import("./features/dashboard/dashboard.component").then((m) => m.DashboardComponent),
        loadChildren: () => import("./features/dashboard/dashboard.routes"),
        canActivate: [AuthGuard],
        data: { authGuardPipe: () => redirectUnauthorizedTo(["login"]) }
    }
];
